module.exports = __webpack_public_path__ + "assets/img/16_1721.81c86a04.jpg";